export default "__VITE_ASSET__C3gNz55i__"